// extracted by mini-css-extract-plugin
export default {"container":"style_container__IIvXo","logo_container":"style_logo_container__mRqqc","image":"style_image__hnyQ9","loading_icon":"style_loading_icon__iUerz","text":"style_text__8lHKO"};